import {
  Box,
  Modal as ChakraModal,
  Flex,
  Text,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalFooter,
  Button,
} from '@chakra-ui/react';
import { RModal } from 'components';
import TournamentBadge from 'components/Tiers/TournamentBadge';
import { IconGoldenModal, IconGoldenTicket, IconRewardsSg } from 'icons';
import { useEffect, useRef } from 'react';

interface GoldenTicketModalProps {
  isOpen: boolean;
  onClose: () => void;
  onGoToTournament: () => void;
  earnedTickets: number;
}

const GoldenTicketModal = ({
  isOpen,
  onClose,
  onGoToTournament,
  earnedTickets,
}: GoldenTicketModalProps) => {
  const explosionVideoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (isOpen && explosionVideoRef.current) {
      explosionVideoRef.current.currentTime = 0;
      explosionVideoRef.current.play();
    }
  }, [isOpen]);

  return (
    <RModal
      isOpen={isOpen}
      onClose={onClose}
      size="2xl"
      isCentered
      title="RACE REWARDS"
      icon={<IconRewardsSg />}
      modalVariant='grey'
    >
      <Flex
        flexDir="column"
        gap={4}
      >
        <Flex
          background="linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%)"
          w="full"
          p="2"
          borderRadius="4px"
        >
          <Text
            fontSize={{ base: '16px', md: '20px' }}
            lineHeight="120%"
            fontWeight="600"
            color="white.80"
          >
            You&apos;ve won a Tournament Ticket! Use this to join the Weekly Tournament before it expires.
          </Text>
        </Flex>

        <Flex
          background="linear-gradient(180deg, #1E2023 0%, #17181A 100%)"
          position="relative"
          borderRadius="4px"
          overflow="hidden"
          _before={{
            content: '""',
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(180deg, rgba(229, 186, 85, 0.6) 0%, rgba(229, 186, 85, 0.12) 100%)',
            padding: '3px',
            borderRadius: '4px',
            mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
            maskComposite: "exclude",
            zIndex: 0,
          }}
          minH={{ base: '200px', md: '342px' }}
          w="full"
          flexDir="column"
          alignItems="center"
          justifyContent="center"
          gap={2}
          p="4"
        >
          <Box
            position="absolute"
            left="0%"
            right="0.15%"
            top="-50%"
            bottom="50%"
            background="#FFDA2C"
            opacity={0.1}
            filter="blur(50px)"
            zIndex={0}
          />
          <Flex
            alignItems="center"
            gap={0}
          >
            <IconGoldenTicket 
              w="6rem"
              h="auto"
            />
            <Text
              fontSize={{ base: '80px', md: '100px' }}
              fontWeight="600"
              lineHeight="80%"
              background="linear-gradient(225deg, #FCF4BF 0%, #EFC862 18%, #CD9832 73%, #BB811B 100%)"
              backgroundClip="text"
              fontStyle="italic"
            >
              {earnedTickets}
            </Text>
          </Flex>
          <Text
            fontSize={{ base: '14px', md: '18px' }}
            lineHeight={{ base: '18px', md: '24px' }}
            fontWeight="600"
            color="cerebralGrey.100"
            textTransform="uppercase"
          >
            Tickets Earned
          </Text>
        </Flex>
      </Flex>
    </RModal>
  );
};

export default GoldenTicketModal;
